<template>
  <div>
    <a-modal
      :visible="visible"
      title=""
      ok-text="确认"
      cancel-text="取消"
      @cancel="cancel"
      @ok="hiedModal"
    >
      <div style="padding-top: 30px">
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
        >
          <a-form-model-item label="设备名称" prop="CurrentIndex">
            <a-select
              v-model="form.CurrentIndex"
              placeholder="请选择"
              style="height: 32px"
            >
              <a-select-option
                v-for="(grade, index) in devicesList"
                :key="grade"
                :value="index"
              >
                {{ grade }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="单双面">
            <a-radio-group v-model="form.IfDuplexEnabled" name="radioGroup">
              <a-radio :value="false"> 单面 </a-radio>
              <a-radio :value="true"> 双面 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="扫描窗口">
            <a-radio-group v-model="form.IfShowUI" name="radioGroup">
              <a-radio :value="false"> 不显示 </a-radio>
              <a-radio :value="true"> 显示 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="分辨率(dpi)" style="margin-bottom: 10px">
            <a-input-number
              v-model="form.Resolution"
              style="margin-left: 10px"
              :min="150"
              :max="600"
              :step="50"
            />
          </a-form-model-item>
          <a-form-model-item label="适配比例" style="margin-bottom: 10px">
            <a-switch v-model="form.isSetsize" style="margin-right: 50px" />
            宽度
            <a-input-number
              v-model="form.setWidth"
              :disabled="!form.isSetsize"
              style="width: 80px"
              :min="150"
              :max="6000"
              :step="100"
            />
            高度
            <a-input-number
              v-model="form.setHeight"
              :disabled="!form.isSetsize"
              style="width: 80px"
              :min="150"
              :max="6000"
              :step="100"
            />
          </a-form-model-item>
          <p style="font-size: 13px; color: rgb(233, 39, 39)">
            分辨率设置可能不成功,具体详细设置,可以勾选扫描窗口显示查看
          </p>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      option: {
        type: Object,
        default: () => []
      },
      devicesList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        rules: {
          CurrentIndex: [
            {
              required: true,
              message: '请选择一个扫描设备',
              trigger: 'blur'
            }
          ]
        },
        form: {
          CurrentIndex: 0,
          IfDuplexEnabled: true,
          IfShowUI: true,
          isSetsize: false,
          setWidth: 1000,
          setHeight: 1000,
          Resolution: 300
        }
      }
    },
    watch: {
      visible(val) {
        if (val) {
          this.resetForm()
        }
      }
    },
    created() {},
    mounted() {},
    methods: {
      async hiedModal() {
        let re = await this.$refs.ruleForm.validate()
        if (!re) return
        this.$emit('hiedModal', { item: this.form, type: 'ok' })
      },
      cancel() {
        this.$emit('hiedModal', { item: this.form, type: 'cancel' })
      },
      resetForm() {
        if (this.option) {
          console.log(this.option)
          this.form = Object.assign({}, this.form, this.option)
        }
        this.$refs.ruleForm?.resetFields()
      }
    }
  }
</script>

<style scoped lang="less"></style>
